<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import StepHost from '../../../../onboarding/components/StepHost.vue'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'onboarding',
    }
})

const {
  stepId,
} = defineProps<{
    stepId: string
}>()
</script>

<template>
  <StepHost :step-id="stepId" />
</template>